import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

// Accept token passed via URL hash from sxtstyles.com
// e.g. portal.sxtstyles.com/tryon#token=eyJ...
const hash = window.location.hash;
if (hash.startsWith('#token=')) {
  const token = hash.slice(7);
  if (token) {
    localStorage.setItem('sxt_token', token);
    // Clean the hash so the token isn't visible or bookmarked
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 2, staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);
